// Web shim for react-native-print using window.print()

const RNPrint = {
  async print(options) {
    if (options?.html) {
      const printWindow = window.open('', '_blank');
      if (printWindow) {
        printWindow.document.write(options.html);
        printWindow.document.close();
        printWindow.focus();
        printWindow.print();
        printWindow.close();
      }
    } else {
      window.print();
    }
  },
};

export default RNPrint;
